import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regional } from '../../_models/regional';
import { ListaItem } from '../../_models/lista-item';
import { ListaService} from '../../_services/lista.service';
import { ExcepcionGMFDestinoService } from '../../_services/excepcion-gmf-destino.service';
import { ExcepcionGMFDestino } from '../../_models/excepcion-gmf-destino';
import {ExcepcionGMF} from '../../_models/excepcion-gmf';

@Component( {
  selector: 'app-excepciones-gmf-destinos-exentos',
  templateUrl: 'excepciones-gmf-destinos-exentos.component.html'
} )

export class ExcepcionesGmfDestinosExentosComponent implements OnInit {
  @Input() regional: Regional;
  @Input() excepcionGMF: ExcepcionGMF;
  excepcionesGMFDestino: ExcepcionGMFDestino [] = [];
  todasExcepcionesGMFDestino: ExcepcionGMFDestino [] = [];

  carInformacionInicial = true;
  acordion: number;
  busqueda: string;
  columnas: any[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  carTabla = true;
  lisAgrupaciones: SelectItem[] = [];
  listaDestinosProducto: SelectItem [] = [];


  constructor( private location: Location,
               private confirmationService: ConfirmationService,
               private excepcionGMFDestinoService: ExcepcionGMFDestinoService,
               private lisServicio: ListaService,
               private navService: NavService,
               private conServicio: ConfirmationService,
               private fb: FormBuilder,
               private route: ActivatedRoute ) {

  }

  ngOnInit() {
    this.cargarFormulario();
    this.cargarServicios();
    this.columnas = [
      { field: 'destino', header: this.navService.buscarMensaje( 'EXCEPCIONESGMF.LBL_DESTINO' ), sort: false },
      { field: 'acciones', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      // Guardar destino-exento
      const excepGMFDesExen = this.formulario.value;
      this.guardando = true;
      this.guardarRegistro( excepGMFDesExen );
    }
  }

  guardarRegistro ( excepGMFDestino: ExcepcionGMFDestino ) {

      const excepGMFDestinoExist = this.todasExcepcionesGMFDestino.find(
        x => x.idDestino === excepGMFDestino.idDestino );
      /**Se verifica si existe un registro con el destino ingresado*/
      if ( excepGMFDestinoExist ) {
        excepGMFDestinoExist.indicadorHabilitado = true;
        this.excepcionGMFDestinoService.actualizar( excepGMFDestinoExist ).subscribe(
          rta => {
            this.guardando = false;
            this.navService.setMesage(1);
            this.formulario.reset();
            this.cargarFormulario();
            this.submitted = false;
            this.cargarServicios();
          },
          error1 => {
            this.navService.setMesage(3);
            this.guardando = false;
          });
      } else {
        /**Se crea un nuevo registro */
        this.excepcionGMFDestinoService.crear( excepGMFDestino ).subscribe(
          res => {
            this.navService.setMesage(1);
            this.formulario.reset();
            this.cargarFormulario();
            this.submitted = false;
            this.cargarServicios();
            this.guardando = false;
          }, error1 => {
            this.navService.setMesage(3);
            this.guardando = false;
          }
        );
      }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

  cargarServicios() {
    /**Limpiamos las listas*/
    this.todasExcepcionesGMFDestino = [];
    this.listaDestinosProducto = [];
    /**Obtenemos los datos */
    forkJoin( this.lisServicio.getMasterDetails('ListasDestinosProductos'),
      this.excepcionGMFDestinoService.obtenerPorIdExcepcionGMF( this.excepcionGMF.idExcepcionGMF )).subscribe(
      ([ lisDesProduct, excepcionGMFDestino ]) => {
        this.todasExcepcionesGMFDestino = excepcionGMFDestino;
        this.excepcionesGMFDestino = this.todasExcepcionesGMFDestino.filter(
          x => x.indicadorHabilitado === true );

        lisDesProduct.map( ( s: ListaItem ) => {
          /**Descartamos los destinos que se encuentran en uso*/
          if ( !(this.excepcionesGMFDestino.find( x => x.idDestino === s.idLista ))) {
            this.listaDestinosProducto.push( { label: s.nombre, value: s.idLista } );
          }
        });
        this.carInformacionInicial = false;
        this.carTabla = false;
      }
    );
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idExcepcionGMFDestino: null,
      idDestino: [ null, [Validators.required ]],
      idExcepcionGMF: [ this.excepcionGMF.idExcepcionGMF, [Validators.required ]],
      indicadorHabilitado: true
    });
  }

  eliminar( excep: ExcepcionGMFDestino) {
    this.carTabla = true;
    excep.indicadorHabilitado = false;
    this.excepcionGMFDestinoService.actualizar( excep ).subscribe(
      res => {
        this.cargarServicios();
      }
    );
  }

  get f() {
    return this.formulario.controls;
  }
}
